/**
 * Parses JSON with a fallback value.
 *
 * @template T - The expected type of the parsed data
 * @param jsonString - The JSON string to parse
 * @param fallback - The fallback value to return on parse failure
 * @returns The parsed data or the fallback value
 *
 * @example
 * const config = parseJsonOr('invalid json', { theme: 'dark' });
 * console.log(config.theme); // 'dark'
 */
export function parseJsonOr<T>(jsonString: string, fallback: T): T {
  try {
    return JSON.parse(jsonString) as T;
  } catch {
    return fallback;
  }
}
